
import React from 'react';

export const BackgroundEffects = () => (
  <>
    <div className="hologram-grid"></div>
    <div className="hologram-rings">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="hologram-ring" style={{
          animationDelay: `${i * 1.5}s`
        }}></div>
      ))}
    </div>
    <div className="hologram-particles">
      {[...Array(15)].map((_, i) => (
        <div key={i} className="hologram-particle" style={{
          '--x': `${Math.random() * 200 - 100}px`,
          '--y': `${Math.random() * 200 - 100}px`,
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 8}s`
        }}></div>
      ))}
    </div>
    <div className="hologram-noise"></div>
    <div className="hologram-glitch"></div>
  </>
);

export const TypingIndicator = () => (
  <div className="flex space-x-2">
    <div className="hologram-typing-dot"></div>
    <div className="hologram-typing-dot" style={{animationDelay: '0.2s'}}></div>
    <div className="hologram-typing-dot" style={{animationDelay: '0.4s'}}></div>
  </div>
); 